import React, { useContext, useState, useEffect } from "react";
import "./SelectRaml.css";
import { Container, Row, Col } from "react-bootstrap";
import SelectRamlComp from "../../components/selectramlcom/SelectRamlComp";
import SelectRamlComp2 from "../../components/selectramlcom/SelectRamlComp2";
import { SelectRamlContext } from "../../contexts/SelectRamContext";
import HeaderB from "../../components/headerb/HeaderB";
import { MainContext } from "../../contexts/MainContext";

export default function SelectRaml() {
  let { setZayechB, setZayechC, setQuestionIdCon, setLotNameCon, setTitleIdCon } = useContext(MainContext);

  const [resobj, setResObj] = useState([]);

  const mainContext = useContext(MainContext);

  useEffect(() => {
    mainContext.setSecondSelectDisabled(true);
    localStorage.removeItem("mainObj2");
    localStorage.removeItem("mainObject");
    setZayechB([]);
    setZayechC([]);
    setQuestionIdCon("");
    setLotNameCon("");
    setTitleIdCon("");
  }, []);

  return (
    <>
      <Container fluid>
        <HeaderB />
      </Container>

      <Container>
        <SelectRamlContext.Provider
          value={{
            resobj,
            setResObj,
          }}
        >
          <Row>
            <Col md={8}>
              <div className="centercc">
                <SelectRamlComp2 />
              </div>
            </Col>
            <Col md={4}></Col>
          </Row>

          <Row>
            <Col>
              <SelectRamlComp />
            </Col>
          </Row>
        </SelectRamlContext.Provider>
      </Container>
    </>
  );
}
